module.exports = __webpack_public_path__ + "img/parser-icons.3cdcbaec.svg";